import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'


/**
 * Obtiene el listado de Instructores (y sus grupos anidados) para el Centro actual.
 */
const GetInstructors = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }
        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetInstructorsForCenters?IdCenter=${idCenter}&rol=${idUserRol}`
        const response = await DoubleAttempt(url, parameters)

        return response.success 
            ? { success: true, data: response.data } 
            : { success: false, message: response.message }
    } catch (error) {
        await LogErrors('GetInstructors - DL Leaders Results', error)
        return { success: false, message: `No ha sido posible obtener la lista de instructores.` }
    }
}

/**
 * Obtiene los cursos asociados a un grupo e instructor específicos.
 */
const GetCoursesByGroup = async (idCenter, idUserRol, idInstructor, idGroup, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idUserRol: idUserRol,
            idInstructor: idInstructor,
            idGroup: idGroup
        }
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetCoursesByGroup`
        const response = await DoubleAttempt(url, parameters)

        return response.success 
            ? { success: true, data: response.data } 
            : { success: false, message: response.message }
    } catch (error) {
        await LogErrors('GetCoursesByGroup - DL Leaders Results', error)
        return { success: false, message: `No ha sido posible obtener los cursos del grupo.` }
    }
}

/**
 * Obtiene las evaluaciones asociadas a un curso específico.
 */
const GetEvaluationsByCourse = async (idCenter, idUserRol, idCourse, token) => {
    try {
        const dataToSend = {
            IdCenter: idCenter,
            IdUserRol: idUserRol,
            IdCourse: idCourse
        }
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetEvaluationsByCourseForAgenda`
        const response = await DoubleAttempt(url, parameters)

        return response.success 
            ? { success: true, data: response.data } 
            : { success: false, message: response.message }
    } catch (error) {
        await LogErrors('GetEvaluationsByCourse - DL Leaders Results', error)
        return { success: false, message: `No ha sido posible obtener las evaluaciones.` }
    }
}

/**
 * Obtiene la exportación masiva de TODOS los resultados de un instructor.
 */
const ReportExportAll = async (idCenter, idUserRol, idInstructor, token) => {
    try {
        const dataToSend = {
            IdCenter: idCenter,
            IdUserRol: idUserRol,
            IdInstructor: idInstructor
        }
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/ReportExportAll`
        const response = await DoubleAttempt(url, parameters)

        return response.success 
            ? { success: true, data: response.data } 
            : { success: false, message: response.message }
    } catch (error) {
        await LogErrors('ReportExportAll - DL Leaders Results', error)
        return { success: false, message: `Error al obtener el reporte global.` }
    }
}

/**
 * Obtiene los intentos agrupados para poblar la tabla principal (con paginación).
 */
const ReportAttemptsGrouped = async (payload, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload) // Payload ya armado desde el BL
        }
        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/ReportAttemptsGrouped`
        const response = await DoubleAttempt(url, parameters)

        return response.success 
            ? { success: true, data: response.data } 
            : { success: false, message: response.message }
    } catch (error) {
        await LogErrors('ReportAttemptsGrouped - DL Leaders Results', error)
        return { success: false, message: `Error al obtener los resultados agrupados.` }
    }
}

/**
 * Obtiene el detalle exhaustivo de un solo intento para armar el Excel individual.
 */
const ReportAttemptDetail = async (payload, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload) // Payload ya armado desde el BL
        }
        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/ReportAttemptDetail`
        const response = await DoubleAttempt(url, parameters)

        return response.success 
            ? { success: true, data: response.data } 
            : { success: false, message: response.message }
    } catch (error) {
        await LogErrors('ReportAttemptDetail - DL Leaders Results', error)
        return { success: false, message: `Error al obtener los detalles del reporte individual.` }
    }
}

export { GetInstructors, GetCoursesByGroup, GetEvaluationsByCourse, ReportExportAll, ReportAttemptsGrouped, ReportAttemptDetail };